import React, { useEffect, useState } from 'react';
import { checkIsVertibular } from '../../../../utils/functions';
import AssessmentsButtons from './AssessmentsButtons';
import VestibularButtons from './VestibularButtons';

function ButtonActions({ loading, goToAssessment, data, attempts, code, type }) {

    const [isVestibular, setIsVertibular] = useState(false);

    useEffect(() => {
        const vestCheck = checkIsVertibular();
        setIsVertibular(vestCheck)
    }, [localStorage]);

    if(isVestibular){
        return (
            <VestibularButtons 
                loading={loading}
                goToAssessment={goToAssessment}
                code={code}
                data={data}
            />
        )
    }

    return (
        <AssessmentsButtons
            loading={loading}
            goToAssessment={goToAssessment}
            data={data}
            attempts={attempts}
            code={code}
            type={type}
        />
    );
}

export default ButtonActions;